import { useState, FC, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import Button from './Button';

export type DateRangeType = {
  startDate?: Date;
  endDate?: Date;
};

interface DateRangeFilterProps {
  setDateRange: (values: DateRangeType) => void;
  dateRange: DateRangeType;
}

const DateRangeFilter: FC<DateRangeFilterProps> = ({
  setDateRange,
  dateRange,
}) => {
  const dateRef = useRef<HTMLDivElement | null>(null);
  const [showFilters, setShowFilters] = useState(false);
  const [startDate, setStartDate] = useState<Date | undefined>(
    dateRange.startDate
  );
  const [endDate, setEndDate] = useState<Date | undefined>(dateRange.endDate);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setShowFilters(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <div className="relative" ref={dateRef}>
      <div
        className="flex justify-center rounded-3xl items-center h-[50px] min-w-[130px] px-2 cursor-pointer bg-[#f3f3f3]"
        onClick={() => setShowFilters(!showFilters)}
      >
        {/* <i className="icon-filters"></i> */}
        <span className="font-medium">Date Filters</span>
      </div>
      {showFilters && (
        <div className="absolute right-0 top-[60px] w-[300px] bg-white border border-[#ddd] p-3 rounded-lg">
          <div className="flex justify-between">
            <h6 className="text-[18px] font-medium mb-3">Filter</h6>
            <span
              onClick={() => {
                setStartDate(undefined);
                setEndDate(undefined);
                setDateRange({
                  startDate: undefined,
                  endDate: undefined,
                });
              }}
              className="font-medium cursor-pointer"
            >
              Reset
            </span>
          </div>
          <div className="flex">
            <div className="p-2">
              <DatePicker
                maxDate={new Date()}
                onChange={(date) => setStartDate(date ?? new Date())}
                selected={startDate ?? new Date()}
                placeholderText="Start Date"
                showMonthDropdown
                showYearDropdown
                className="h-[40px] w-full px-2 focus:outline-none border border-gray-400 rounded-3xl"
              />
            </div>
            <div className="p-2 mb-3">
              <DatePicker
                maxDate={new Date()}
                minDate={startDate}
                onChange={(date) => setEndDate(date ?? new Date())}
                selected={endDate ?? new Date()}
                placeholderText="End Date"
                showMonthDropdown
                showYearDropdown
                className="h-[40px] w-full px-2 focus:outline-none border border-gray-400 rounded-3xl"
              />
            </div>
          </div>
          <Button
            classes="w-full"
            onClick={() => setDateRange({ startDate, endDate })}
            disabled={!startDate || !endDate}
            type="button"
          >
            Search
          </Button>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
